export default __webpack_public_path__ + "static/media/cat3-3.672c3d79.jpg";